export default __webpack_public_path__ + "static/media/36I-102623_-15522_0.3fafdd2b.jpg";